import {API_counterparties} from "../../api/systemManager/api.counterparties";

export function AddOrganizationByRoleId (role: 5 | 3 | 4, userId, verCenterId?: string, medId?: string, orgId?: string) {
const {addOrganizationByMedId, addVerCenter, addMedCenter, addOrganization} = API_counterparties.addingOrganization


switch (role) {
    case 3:
        return medId ? addOrganizationByMedId(userId, verCenterId, medId) :  addOrganization(userId, verCenterId)
    case 4:
        return addMedCenter(userId, verCenterId)
    case 5:
        return addVerCenter(userId)
    default:
        return {api: "", method: ""}
}





}